import React, { useMemo } from 'react'
import { useObservable } from 'rxjs-hooks'

import PersonIcon from '@mui/icons-material/Person'
import { Avatar as MuiAvatar } from '@mui/material'
import { getInitials, useAuthService } from '@procom-labs/common'

export const Avatar: React.FC<{
  color: string
  isSmall?: boolean
}> = ({ color, isSmall }) => {
  const authService = useAuthService()
  const currentUser = useObservable(() => authService.currentUser$)
  const initials: string = useMemo(
    () =>
      `${getInitials(currentUser?.firstName ?? '')}${getInitials(
        currentUser?.lastName ?? ''
      )}`,
    [currentUser]
  )

  return (
    <MuiAvatar
      sx={{
        backgroundColor: color,
        width: isSmall ? 32 : 40,
        height: isSmall ? 32 : 40,
        color: 'common.white',
        border: 'solid 2px',
        fontSize: isSmall ? '15px' : '2rem',
      }}
    >
      {currentUser?.firstName && currentUser?.lastName ? (
        initials.toUpperCase()
      ) : (
        <PersonIcon
          sx={{
            color: (theme) => theme.palette.common.white,
          }}
        />
      )}
    </MuiAvatar>
  )
}
